import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  OnInit,
  ViewChild,
  ElementRef,
  ChangeDetectionStrategy
} from '@angular/core';

import { ImageCroppedEvent, ImageCropperComponent } from 'ngx-image-cropper';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoaderComponent } from '@common/components/loader/loader.component';
import { environment } from 'projects/speaker-platform/src/environments/environment';
import { Constants } from '@common/config/constants';
import { AtsappService } from '@common/services/atsapp.service';

@Component({
  selector: 'app-speaker-edit-presentation',
  imports: [
    ImageCropperComponent,
    FormsModule,
    ReactiveFormsModule,
    LoaderComponent
],
  templateUrl: './speaker-edit-presentation.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./speaker-edit-presentation.component.scss']
})
export class SpeakerEditPresentationComponent implements OnChanges, OnInit {
  constructor(
    private fb: FormBuilder,
    protected constants: Constants,
    private atsappService: AtsappService
  ) {}

  @ViewChild('medleyFileInput') medleyFileInput!: ElementRef;
  @ViewChild('photoFileInput') photoFileInput!: ElementRef;

  @Output() savePresentationEvent = new EventEmitter();
  @Output() isPristine = new EventEmitter<boolean>();

  @Input() medley: string | null = '';
  @Input() photo: string | null = '';
  @Input() biographie: string | null = '';
  @Input() isLoading: boolean = false;
  @Input() readOnly: boolean = false;
  @Input() codespeak: string = '';

  env = environment;

  imageChangedEvent: any = '';
  croppedImage: any = '';

  medleyObjectURL: any = '';

  editSpeakerPresentation = this.fb.group({
    medley: [this.medley],
    photo: [null],
    biographie: [this.biographie],
  });

  ngOnInit(): void {
    if (this.readOnly) {
      this.editSpeakerPresentation.disable();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['codespeak']) {
      this.loadMedley();
    }

    this.croppedImage = null;
    this.imageChangedEvent = null;
    // this.medleyFileInput.nativeElement.value = this.medley;
    this.editSpeakerPresentation.patchValue({
      medley: this.medley,
      photo: null,
      biographie: this.biographie,
    });
  }

  loadMedley() {
    this.medleyObjectURL = this.medley ? this.constants.ATSAPP_BASE_URL + '/speaker-files' + this.medley : '';
  }

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
    this.editSpeakerPresentation.markAsDirty();
  }

  imageCropped(event: ImageCroppedEvent) {
    const reader = new FileReader();

    if (event.blob) {
      reader.readAsDataURL(event.blob);
      reader.onload = () => {
        this.croppedImage = reader.result;
        if (event.blob) {
          //@ts-expect-error
          this.editSpeakerPresentation.patchValue({ photo: event.blob });
        }
      };
    }
  }

  saveMedleyFile(event: any) {
    const reader = new FileReader();
    const target = event.target as HTMLInputElement;

    if (target.files && target.files.length) {
      const file = target.files[0];
      this.medleyObjectURL = URL.createObjectURL(file);

      reader.readAsArrayBuffer(file);
      reader.onload = () => {
        this.editSpeakerPresentation.patchValue({
          //@ts-expect-error
          medley: new File([reader.result], file.name, { type: file.type }),
        });
      };

      this.editSpeakerPresentation.controls['medley'].markAsDirty();
    }

    this.editSpeakerPresentation.patchValue({ medley: event.target.files[0] });
    this.editSpeakerPresentation.markAsDirty();
  }

  resetForm() {
    this.editSpeakerPresentation.reset({
      medley: this.medley,
      photo: null,
      biographie: this.biographie,
    });
    this.medleyFileInput.nativeElement.value = null;
    this.photoFileInput.nativeElement.value = null;
    this.croppedImage = null;
    this.imageChangedEvent = null;
    this.loadMedley();
    this.updatePristineStatus();
  }

  savePresentation() {
    const formData = new FormData();

    for (let [k, v] of Object.entries(this.editSpeakerPresentation.value)) {
      if (v !== null) {
        formData.append(k, v);
      }
    }

    this.savePresentationEvent.emit(formData);
  }

  updatePristineStatus() {
    this.isPristine.emit(this.editSpeakerPresentation.pristine);
  }
}
